import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Utils from "@base/utils/Utils";

export default class FeatureStartState extends BaseState {

  begin() {
    this.model.randomTime = Utils.randomNumber(1000, 2500)

    Signals.forceRoundEnd.add(this.onForceRoundEnd, this)
    Signals.featureServerHappened.add(this.end, this)
    Signals.startFeature.dispatch()
  }

  end = () => {
    this.stateMachine.setState(GameStatesEnum.STOP_FEATURE)
  }

  onForceRoundEnd() {
    this.stateMachine.setState(GameStatesEnum.ROUND_END)
  }

  onSocketClosed() {
    this.stateMachine.setState(GameStatesEnum.RECONNECT_SOCKET)
  }

  cleanUp() {
    Signals.forceRoundEnd.remove(this.onForceRoundEnd, this)
    Signals.featureServerHappened.remove(this.end, this)
   }
}
